export class InteractionOffer {
    static merge(to: InteractionOffer, from: InteractionOffer) {
        const accumulate = (fieldName: string) => {
            if (from[fieldName]) {
                to[fieldName] = (!to[fieldName] ? 0 : to[fieldName]) + from[fieldName];
            }
        };
        accumulate("pgViewCount");
        accumulate("pgViewTime");
        accumulate("pgOpenCount");
        accumulate("pgOpenTime");
        accumulate("pgShareCount");
        accumulate("pgShareTime");
        accumulate("pgShowCashierCount");
        accumulate("pgShowCashierTime");
        accumulate("tapShareCount");
        accumulate("tapCameraCount");
        accumulate("tapGalleryCount");
        accumulate("tapDirectionsCount");
        accumulate("tapWebsiteCount");
        accumulate("tapReviewCount");
    }

    pgViewCount?: number;
    pgViewTime?: number;
    pgOpenCount?: number;
    pgOpenTime?: number;
    pgShareCount?: number;
    pgShareTime?: number;
    pgShowCashierCount?: number;
    pgShowCashierTime?: number;

    tapShareCount?: number;
    tapCameraCount?: number;
    tapGalleryCount?: number;
    tapDirectionsCount?: number;
    tapWebsiteCount?: number;
    tapReviewCount?: number;
}
